"use client";

import { CircleAlert } from "lucide-react";

import { useErrorLogs } from "@/src/lib/data-fetchers/error-log-fetchers";
import { getActionableInstruction } from "@/src/models/error-log";

interface SyncIncompleteActionsProps {
  taskId: string;
}

export function SyncIncompleteActions({ taskId }: SyncIncompleteActionsProps) {
  const { errorLogs } = useErrorLogs(taskId);

  if (errorLogs.length === 0) return null;

  const uniqueInstructions = [...new Set(errorLogs.map((log) => getActionableInstruction(log)))];

  return (
    <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4">
      <div className="flex items-center gap-2 mb-3">
        <CircleAlert className="h-4 w-4 text-destructive" />
        <h3 className="font-semibold text-destructive">
          Sync Incomplete — {uniqueInstructions.length}{" "}
          {uniqueInstructions.length === 1 ? "step requires" : "steps require"} manual attention
        </h3>
      </div>
      <ul className="list-disc pl-5 space-y-1.5 text-sm text-foreground">
        {uniqueInstructions.map((instruction) => (
          <li key={instruction}>{instruction}</li>
        ))}
      </ul>
    </div>
  );
}
